<template>
    <v-card v-bind="$attrs" v-on="eventsHandler" elevation="0" rounded color="white">
        <div class="pa-16 pb-10">
            <div class="mb-10">
                <v-row align="center" class="row--small">
                    <v-col v-if="selectable" cols="auto">
                        <v-simple-checkbox :value="isSelected" v-on="eventsHandler" color="primary" />
                    </v-col>
                    <v-col>
                        <v-layout class="flex-row flex-lg-column flex-xl-row align-center align-lg-start align-xl-center">
                            <h5 class="page-text--lg font-weight-medium grey-13--text mr-4">
                                {{ value?.resume?.personalInformation?.name }}
                            </h5>
                            <p class="page-text--sm grey-9--text">({{ gender }}, {{ age }})</p>
                        </v-layout>
                    </v-col>
                    <v-col cols="auto">
                        <v-avatar color="grey" class="v-avatar--small">
                            <v-img :src="profileSrc">
                                <v-fade-transition>
                                    <v-icon v-show="!profileSrc" color="white">mdi-account</v-icon>
                                </v-fade-transition>
                            </v-img>
                        </v-avatar>
                    </v-col>
                </v-row>
            </div>
            <ul class="dot-texts">
                <li v-for="text in cardTextList" :key="text" class="dot-text page-text--sm grey-6--text">· {{ text }}</li>
            </ul>
        </div>
        <v-divider />
        <div class="px-8 py-2">
            <v-row class="row--small">
                <v-col cols="auto">
                    <v-row no-gutters>
                        <v-col>
                            <application-view v-bind="{ value, recruitment }" @input="(value) => $emit('input', value)">
                                <template #activator="{ attrs, on }">
                                    <v-btn v-bind="attrs" v-on="on" icon text small color="grey-9">
                                        <v-icon> mdi-checkbox-multiple-blank-outline </v-icon>
                                    </v-btn>
                                </template>
                            </application-view>
                        </v-col>
                        <v-col class="ml-n8">
                            <like-btn :params="{ _application: value?._id, type: USER_LIKE_TYPES.APPLICATION.value }">
                                <template #activator="{ active, toggle }">
                                    <v-btn :color="active ? 'yellow darken-1' : 'grey-9'" icon text small @click.stop.prevent.capture="() => !selectable && toggle()">
                                        <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                                    </v-btn>
                                </template>
                            </like-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- <v-spacer />
                <v-col cols="auto">
                    <v-btn icon text small color="grey-9">
                        <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                </v-col> -->
            </v-row>
        </div>
    </v-card>
    <!-- <v-card flat rounded="lg" :dark="isSelected" :color="isSelected ? 'primary' : undefined" v-bind="$attrs" v-on="eventsHandler">
        <v-card-title>
            <span>
                <v-simple-checkbox v-if="selectable" :value="isSelected" v-on="eventsHandler" class="d-inline" />
                <span class="font-size-28">{{ value?.resume?.personalInformation?.name }}</span>
                <span class="font-size-18 txt-grey-color font-weight-regular"> ({{ gender }}, {{ age }}) </span>
            </span>
            <like-btn :params="{ _userPerson: value?._applicant, type: USER_LIKE_TYPES.USER_PERSON.value }">
                <template #activator="{ active, toggle }">
                    <v-btn icon text small :color="active ? 'pink lighten-2' : undefined" @click.stop.prevent.capture="() => !selectable && toggle()">
                        <v-icon small>{{ active ? "mdi-heart" : "mdi-heart-outline" }}</v-icon>
                    </v-btn>
                </template>
            </like-btn>
            <v-spacer />
            <v-avatar color="grey darken-1" size="30">
                <v-img :src="profileSrc">
                    <v-fade-transition>
                        <v-icon v-show="!profileSrc" color="white">mdi-account</v-icon>
                    </v-fade-transition>
                </v-img>
            </v-avatar>
        </v-card-title>
        <v-card-text>
            <v-row v-for="text in cardTextList" :key="text" no-gutters>
                <v-col cols="auto"> <v-icon small color="grey lighten-1">mdi-circle-small</v-icon> </v-col> <v-col>{{ text }}</v-col>
            </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-10">
            <application-view v-bind="{ value, recruitment }" @input="(value) => $emit('input', value)">
                <template #activator="{ attrs, on }">
                    <v-icon v-bind="attrs" v-on="on"> mdi-checkbox-multiple-blank-outline </v-icon>
                </template>
            </application-view>
            <like-btn :params="{ _application: value?._id, type: USER_LIKE_TYPES.APPLICATION.value }">
                <template #activator="{ active, toggle }">
                    <v-btn icon text :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="() => !selectable && toggle()">
                        <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                    </v-btn>
                </template>
            </like-btn>
            <v-spacer />
            <v-icon>mdi-dots-horizontal</v-icon>
        </v-card-actions>
    </v-card> -->
</template>

<script>
import dayjs from "dayjs";
import { EDUCATION_ATTENDING_STATUSES, EDUCATION_INSTITUTION_TYPES, GENDERS, USER_LIKE_TYPES } from "@/assets/variables";

import LikeBtn from "@/components/client/like/like-btn.vue";
import ApplicationView from "./application-view.vue";

export default {
    components: {
        LikeBtn,
        ApplicationView,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // application
        selectable: { type: Boolean, default: false },
        isSelected: { type: Boolean, default: false },
        recruitment: { type: Object, default: () => ({}) },
    },
    data: () => ({
        USER_LIKE_TYPES,
    }),
    computed: {
        gender() {
            return GENDERS[this.value?.resume?.personalInformation?.gender]?.text;
        },
        age() {
            let { bornAt } = this.value?.resume?.personalInformation || {};
            if (bornAt) bornAt = `${dayjs().diff(bornAt, "year")}세`;
            return bornAt;
        },
        profileSrc() {
            return this.value?.resume?.profile?.url;
        },
        area() {
            let { address1 } = this.value?.resume?.personalInformation?.residence || {};
            return address1?.split?.(" ")?.slice?.(0, 2)?.join?.(" ");
        },
        education() {
            let { institutionType, attendingStatus } = this.value?.resume?.education || {};

            let education = "";
            if (institutionType) education += `${EDUCATION_INSTITUTION_TYPES[institutionType]?.text || ""} `;
            if (attendingStatus) education += `${EDUCATION_ATTENDING_STATUSES[attendingStatus]?.text || ""} `;
            return education.trim();
        },
        cardTextList() {
            return [this.value?.resume?.personalInformation?.phone, this.area, this.education];
        },
        eventsHandler() {
            if (this.selectable)
                return {
                    click: () => {
                        this.$emit("select");
                    },
                };
        },
    },
    methods: {
        log() {
            console.log("called");
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .theme--light.v-divider,
::v-deep .theme--dark.v-divider {
    border-color: var(--border-color);
}
</style>